var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c("transition", { attrs: { name: "fade", mode: "out-in" } }, [
        _vm.displayForm
          ? _c(
              "div",
              { key: "contactForm", staticClass: "p-5" },
              [
                _c("contact-form", {
                  attrs: { contact: _vm.selectedContact },
                  on: {
                    cancel: function ($event) {
                      _vm.displayForm = false
                    },
                  },
                }),
              ],
              1
            )
          : _c("div", { key: "contact-departments" }, [
              _c(
                "div",
                { staticClass: "contact-page department-container" },
                [
                  _c("div", { staticClass: "contact-header" }, [
                    _c("div", { staticClass: "container" }, [
                      _c("h1", [_vm._v("Contact Us")]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.groupedByDept, function (g, i) {
                    return _c(
                      "div",
                      {
                        key: "dc" + i,
                        class: "container " + g[0].parentDeptSelector,
                      },
                      [
                        _c("div", [
                          _c("h2", { staticClass: "contact-title" }, [
                            _vm._v(_vm._s(g[0].parentDeptTitle)),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "row px-4 py-5 bordered contact-stubs-container",
                          },
                          _vm._l(g, function (c) {
                            return _c("contact-stub", {
                              key: "c" + c.contactID,
                              attrs: { contact: c },
                              on: {
                                displayContactForm: _vm.displayContactForm,
                              },
                            })
                          }),
                          1
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
            ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }